import React from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";

const PageError = ({ error, exitLink, exitText, resetErrorBoundary, ...props }) => {
    return (
        <div className="flex items-center justify-center">
            <div className="page-error" style={TB.createStyledCircle(TB.config("color.danger"), 0.1)}>

                <div className="white-panel">
                    <i className="fas fa-exclamation-circle text-danger fa-5x"/>
                    <h3>Something went wrong</h3>

                    <p>It appears there was something on this page caused an issue and we are looking into it. Please try again later.</p>

                    <Link
                        to={exitLink || TB.auth().appropriate() || '/dashboard'}
                        replace={true}
                        className="btn btn-dark mt-2">
                        {exitText || 'Return to dashboard'}
                    </Link>
                </div>

            </div>
        </div>
    );
};

PageError.propTypes = {
    exitLink: PropTypes.any,
    exitText: PropTypes.any,
};

export default PageError;